import * as tslib_1 from "tslib";
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
import * as i2 from "@ngx-translate/core";
var RecoveryCodesService = /** @class */ (function () {
    function RecoveryCodesService(sanitizer, translateService) {
        this.sanitizer = sanitizer;
        this.translateService = translateService;
    }
    RecoveryCodesService.prototype.generateFileToDownload = function (_a) {
        var _this = this;
        var recoveryCodes = _a.recoveryCodes, userEmail = _a.userEmail;
        var formattedRecoveryCodes = recoveryCodes.map(function (code, index) {
            var text = index + 1 + ". " + code.plainTextCode;
            if (code.status === 'CURRENT_ACTIVE') {
                return text;
            }
            return _this.translateService.instant('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOCUMENT.CODE_UTILIZED', {
                position: index + 1,
                code: code.plainTextCode,
            });
        });
        var fileContent = tslib_1.__spread([
            this.translateService.instant('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOCUMENT.TITLE'),
            "(" + userEmail + ")",
            ''
        ], formattedRecoveryCodes, [
            '',
            this.translateService.instant('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOCUMENT.WARNINGS'),
            this.translateService.instant('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOCUMENT.CREATED_AT', {
                createdAt: moment(recoveryCodes[0].createdAt).format('DD/MM/YYYY')
            })
        ]).join('\n');
        var file = new Blob([fileContent], {
            type: 'text/plain;charset=utf-8'
        });
        var urlFile = URL.createObjectURL(file);
        return this.sanitizer.bypassSecurityTrustUrl(urlFile);
    };
    RecoveryCodesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RecoveryCodesService_Factory() { return new RecoveryCodesService(i0.ɵɵinject(i1.DomSanitizer), i0.ɵɵinject(i2.TranslateService)); }, token: RecoveryCodesService, providedIn: "root" });
    return RecoveryCodesService;
}());
export { RecoveryCodesService };
